import React, { useRef, useState } from 'react';

import { Popup, ToolbarItem } from 'devextreme-react/popup';
import Form, { SimpleItem, GroupItem, Label, EmptyItem, StringLengthRule, RequiredRule, EmailRule, AsyncRule } from 'devextreme-react/form';
import { Button } from 'devextreme-react/button';

import { useDispatch, useSelector } from 'react-redux'
import { dialogCatalog } from '../../store/catalog/catalogDialogReducer';
import { Lookup } from 'devextreme-react';
import http from '../../utils/http';
import uri from '../../utils/uri';
import notify from 'devextreme/ui/notify';

const NewCatalog = ({ list=[]}) => {

    const catalogId = list.length == 1 ? list[0].id : 0;

    const { open } = useSelector(store => store.catalog2);
    const [ saving, setSaving ] = useState(false);
    const [ catalog, setCatalog ] = useState({ id: 0, name: '', catalogId: catalogId });
    const [ catalogs ] = useState([...list]);

    const refCatalog = useRef();
    const dispatch = useDispatch();

    const closeDialog = (load) => {

        setCatalog({ id: 0, name: '', catalogId: 0 });
        dispatch(dialogCatalog({ open: false, id: 0 }));
      
    }

    const onHiding = ({ load }) => {

        closeDialog(load);

    }

    const guardarCatalog = () => {
        
        if (refCatalog.current.instance.validate().isValid) {

            setSaving(true);

            http(uri.new_catalog).asPost({ ...catalog })
            .then(resp => {
                setSaving(false);
                notify(`Catalogo creado correctamente`);
                closeDialog(true);
            })
            .catch(err => {
                setSaving(false);
                notify(err, 'error');
            })
            
        }
    }

    return (
        <div>
            <Popup
                width={300}
                height={200}
                title={`Nuevo catalogo`}
                onHiding={onHiding}
                visible={open}
                className="bg-fbfbfb"
            >
                <Form formData={catalog} ref={refCatalog}>                       
                    <SimpleItem dataField="name" >
                        <Label text="Nombre" />
                        <RequiredRule message="Ingrese el nombre" />
                    </SimpleItem>
                    <SimpleItem dataField={'catalogId'} editorType={'dxSelectBox'} 
                    editorOptions={{ dataSource: catalogs, valueExpr: 'id', displayExpr: 'name' }}>
                        <Label text="Catalogo" />
                        <RequiredRule message="Seleccione un catalogo" />
                    </SimpleItem>

                </Form>
                <div>
                    <Button
                        width={120}
                        text={`${saving ? 'Guardando...' : 'Guardar'}`}
                        type="default"
                        icon="save"
                        stylingMode="contained"
                        className="m-1"
                        disabled={saving}
                        onClick={guardarCatalog}
                        />
                </div>
            </Popup>
        </div>
    );
}

export default NewCatalog;
